import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Table } from "../../../../../components/ui/Table";
import { FormatInt } from "../../../../../utils/FormatData";
const TablePartners = (props) => {
  const { data } = props;

  const COLUMNS = useMemo(() => {
    if (!data.length) {
      return [];
    }

    return [
      {
        Header: "Fecha de envio",
        accessor: "dt_sent",
      },
      {
        Header: "Campaña",
        accessor: "vc_campaign",
      },
      {
        Header: "Partner",
        accessor: "vc_partner",
      },
      {
        Header: "Enviados",
        accessor: "i_sent",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_sent);
          return FormatInt(value);
        },
      },
      {
        Header: "Single",
        accessor: "i_single",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_single);
          return FormatInt(value);
        },
      },
      {
        Header: "Basic",
        accessor: "i_basic",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_basic);
          return FormatInt(value);
        },
      },
      {
        Header: "Entregados RCS",
        accessor: "i_deliveredrcs",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_deliveredrcs);
          return FormatInt(value);
        },
      },
      {
        Header: "Fallbacks SMS",
        accessor: "i_fallback",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_fallback);
          return FormatInt(value);
        },
      },
      {
        Header: "Rechazados",
        accessor: "i_rejected",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_rejected);
          return FormatInt(value);
        },
      },
      {
        Header: "Leidos",
        accessor: "i_readed",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_readed);
          return FormatInt(value);
        },
      },
    ];
  }, [data]);
  return (
    <Table
      data={data}
      columns={COLUMNS}
      config={{
        search: true,
        footer: true,
        printfooter: true,
        pageSize: 10,
        perPage: 10,
        export: true,
      }}
    />
  );
};

TablePartners.propTypes = {
  data: PropTypes.array,
};

export default TablePartners;
